import { createContext } from 'react';

import type { SnackbarOrigin } from '@mui/material';

import type { NotificationSeverity } from '../../providers/NotificationProvider/NotificationProvider';

export interface NotificationContextType {
  show: (
    message: string,
    options?: {
      severity?: NotificationSeverity;
      autoHideDuration?: number;
      position?: SnackbarOrigin;
    },
  ) => number;
  close: (key: number) => void;
}

export const NotificationContext = createContext<NotificationContextType | undefined>(undefined);
